<template>
  <div class="pagination">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="currentPage"
      :page-size="limit"
      :total="total"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  name: "pagination",
  data() {
    return {
      currentPage: 1, // 当前页
      // limit: 10, // 每页显示数量
      // total: 0 // 总页数
    };
  },
  props: {
    // 避免直接改变prop属性
    // currentPage: {
    //   required: false,
    //   default: 1
    // },
    total: {
      required: false,
      default: 0
    },
    limit: {
      required: false,
      default: 10
    }
  },
  watch: {
    currentPage(val) {
      // 改变这个值并不会触发 handleCurrentChange
      if (typeof val === "number") {
        console.log("prop currentPage!!!");
        this.currentPage = val;
      }
    }
  },
  methods: {
    init(){
      this.currentPage = 1;
    },
    // 当前页变化
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    // size变化
    handleSizeChange(val) {
      this.currentPage = 1;
      this.$emit("handleSizeChange", val);
    }
  }
};
</script>
<style lang="less" scoped>
.el-pagination{
  text-align: center;
}
</style>